import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Users/';

const login = async (user) => axiosInstance.post(`${ENDPOINTORIGIN}Authenticate`, user, constants.REQUIRE_INTERCEPTORS);

const register = async (user) => axiosInstance.post(`${ENDPOINTORIGIN}Register`, user, constants.REQUIRE_INTERCEPTORS);

const getUserById = async (userId) => axiosInstance.get(`${ENDPOINTORIGIN}GetUser?id=${userId}`, constants.REQUIRE_INTERCEPTORS);

const getLoggedInUser = async () => axiosInstance.get(`${ENDPOINTORIGIN}GetLoggedInUser`, constants.REQUIRE_INTERCEPTORS);

const getAllUsers = async () => axiosInstance.get(`${ENDPOINTORIGIN}GetAllUsers`, constants.REQUIRE_INTERCEPTORS);

const updateUser = async (user) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateUser`, user, constants.REQUIRE_INTERCEPTORS);

const changeUserPassword = async (userId, password) => axiosInstance.put(`${ENDPOINTORIGIN}ChangeUserPassword?userId=${userId}&password=${password}`, {}, constants.REQUIRE_INTERCEPTORS);

const changeSelfPassword = async (password) => axiosInstance.put(`${ENDPOINTORIGIN}ChangeSelfPassword?password=${password}`, {}, constants.REQUIRE_INTERCEPTORS);

const logOutTempUser = async () => axiosInstance.get(`${ENDPOINTORIGIN}LogOutTempUser`, constants.REQUIRE_INTERCEPTORS);

export {
  login,
  register,
  getUserById,
  getLoggedInUser,
  getAllUsers,
  updateUser,
  changeUserPassword,
  changeSelfPassword,
  logOutTempUser
};